import MDivider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import MTab from "@mui/material/Tab";
import MTabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";

import { CustomerPortalListItem } from "../../../../CustomerPortalListItem";

const Divider = styled(MDivider)(() => ({
  marginLeft: "-24px",
  marginRight: "-24px",
}));

const Tab = styled(MTab)(() => ({}));

const Tabs = styled(MTabs)(() => ({}));

const TabPanelContainer = styled(SwipeableViews)(({ theme }) => ({
  paddingTop: "24px",
  paddingBottom: "24px",

  [theme.breakpoints.up("md")]: {
    paddingTop: "32px",
    paddingBottom: "32px",
  },

  [`& .react-swipeable-view-container > div`]: {
    overflow: "visible !important",
  },
}));

const InfoWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

const InfoContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    gap: "24px",
  },
}));

const InfoContainerListItem = styled(CustomerPortalListItem)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flex: "1 1 0px",
  minWidth: 0,
  "& > *": {
    wordBreak: "break-all",
  },
}));

const InfoContainerMobileTitle = styled(Typography)(() => ({
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px" /* 150% */,
  letterSpacing: "0.15px",
}));

const InfoContainerMobileListItem = styled(Typography)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

const EmptyStateText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
}));

const CustomerDetail = styled("span")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "8px",
}));

export {
  CustomerDetail,
  Divider,
  EmptyStateText,
  Tab,
  Tabs,
  TabPanelContainer,
  InfoWrapper,
  InfoContainer,
  InfoContainerListItem,
  InfoContainerMobileTitle,
  InfoContainerMobileListItem,
};
